import { computed, type ComputedRef } from 'vue'
import { useRoute } from 'vue-router'

import {
  freePlanLockedRoute,
  getAccountDetailPackageId,
  isFreePlanPackage,
  useAccount,
  type FreePlanLockedRoute,
} from '@/features/account'

/**
 * The current route's Free-plan lock, or `null`. One read shared by `FreePlanRouteGate` (which
 * renders the locked screen) and the shell (which keeps the sidebar on a locked full-bleed route
 * such as Orpheus), so the two cannot disagree about whether the user is looking at a lock.
 */
export function useFreePlanRouteLock(): ComputedRef<FreePlanLockedRoute | null> {
  const route = useRoute()
  const account = useAccount()
  return computed(() =>
    isFreePlanPackage(getAccountDetailPackageId(account.accountDetail.value))
      ? freePlanLockedRoute(route.name)
      : null,
  )
}
